<div class="wrap">
    <div class="container">
        <app-header></app-header>
    </div>
    <div class="aviso-container flex flex-col space-y-10 pt-36">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-xl font-bold text-customPurple-600 mb-4 text-center">
                Términos y Condiciones
            </h1>

            <div className="space-y-6 text-customBlack-500">
                <p className="text-justify">
                    Las presentes condiciones generales (en lo sucesivo, las "Condiciones Generales") son obligatorias
                    entre aquellas personas que decidan solicitar el Crédito (en adelante el "Prestatario"), incluyendo
                    a los visitantes de la página web: https://teu.mx/ (la "Página Web"), y de la Aplicación Móvil
                    denominada "Teu Crédito" (la "App" y en conjunto con la Página Web, la "Plataforma") propiedad de
                    Teu Technologies SAPI DE CV (en lo sucesivo, "Acreditante") aplicables al Crédito (en lo sucesivo,
                    el "Crédito") y en conjunto se les denominara las "Partes".
                </p>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        Aceptación
                    </h2>
                    <p className="text-justify">
                        Al usar la Plataforma Teu Crédito, usted manifiesta su consentimiento a los presentes Términos y
                        Condiciones, aun cuando no se encuentre registrado o tenga una Cuenta en dicha Plataforma. Teu
                        Crédito se reserva el derecho de adicionar o modificar los Términos y Condiciones en cualquier
                        momento, mediante la publicación en la Plataforma, sin necesidad de notificar al Usuario en
                        ningún momento. Todas las modificaciones surtirán efectos en el momento en que sean publicadas
                        en la Plataforma.
                    </p>
                    <p className="text-justify mt-4">
                        Aun cuando Usted no complete su registro para contratar el crédito de la Plataforma, los
                        presentes Términos y Condiciones le serán aplicables para todo el uso que haga de la misma, es
                        decir, estos Términos y Condiciones regulan también el uso de la Plataforma para visitantes de
                        la misma.
                    </p>
                    <p className="text-justify mt-4">
                        Cualquier incumplimiento a estos Términos y Condiciones faculta a Teu Technologies SAPI de CV a
                        dar por terminada cualquier relación con el Prestatario de manera inmediata, sin ningún tipo de
                        responsabilidad a cargo de Teu Technologies SAPI de CV y sin necesidad de requerimiento judicial
                        o extrajudicial.
                    </p>
                    <p className="text-justify mt-4">
                        Aceptación al utilizar medios electrónicos de autenticación: Las partes acuerdan que el
                        Prestatario podrá expresar su consentimiento respecto a los presentes Términos y Condiciones,
                        así como tener acceso a los servicios ofrecidos por Teu Crédito mediante medios electrónicos
                        tales como NIP
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        1.- Aprobación del Crédito
                    </h2>
                    <p className="text-justify">
                        Cuando Acreditante apruebe la solicitud de crédito del Prestatario, la confirmación de la
                        aprobación y el desembolso efectivo del importe del préstamo estarán sujetos a que:
                    </p>
                    <p className="text-justify mt-4">
                        (i). - El Acreditante se cerciore de que la información facilitada no era inexacta o deficiente
                        en ningún aspecto (si Acreditante determina que sí lo fue, el Crédito será nulo y, en su caso,
                        tal circunstancia podrá ser notificada a las sociedades de información crediticia).
                    </p>
                    <p className="text-justify mt-4">
                        (ii). - Si el Acreditante compruebe su historial de crédito y la información facilitada para
                        evaluar la asequibilidad del crédito.
                    </p>
                    <p className="text-justify mt-4">
                        Las Partes están de acuerdo en que será facultad exclusiva del Acreditante el otorgamiento del
                        Crédito.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        2.- Límites del Crédito
                    </h2>
                    <p className="text-justify">
                        El Crédito deberá estar documentado a elección del Acreditante por medio de un título de crédito
                        y/o por medio de un contrato o y/o por medio de cualquier documento que el Acreditante estime
                        pertinente, dicho(s) documento(s) establecerán el importe total máximo de fondos a ser
                        dispuestos por el Prestatario (en lo sucesivo, el "Documentos del Crédito"). El Prestatario
                        podrá efectuar disposiciones sólo hasta el importe máximo del Crédito. El Acreditante podrá
                        negar la disposición a préstamo de las cantidades que excedan dicho importe. Sin perjuicio de
                        haberle a autorizado a ello con anterioridad. Si, por cualquier motivo, la cantidad total
                        prestada al Prestatario excediere el importe total de los Documentos del Crédito, el Acreditante
                        podrá requerir al Prestatario el reembolso inmediato de toda cantidad que excediere el monto
                        máximo comprometido.
                    </p>
                    <p className="text-justify mt-4">
                        Cada solicitud de disposición, dentro del Documentos del Crédito, no podrá ser inferior a
                        $1,000.00 (Mil pesos 00/100 M.N.)
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        3.- Intereses y Accesorios
                    </h2>
                    <p className="text-justify">
                        El Crédito puede generar en favor del Acreditante el pago de intereses ordinarios y/o moratorios
                        y/o comisiones (en lo sucesivo, las "Accesorios"). Dichos Accesorios deberán ser aceptados por
                        el Prestatario antes de poder hacer uso del correspondiente del Crédito. Asimismo, los
                        Accesorios estarán contemplados en los Documentos del Crédito en donde constará su periodicidad
                        y forma de pago. Los Accesorios no incluyen contribuciones, derechos o impuestos de ninguna
                        índole y que sean pagaderos a las autoridades hacendarias en México. El Prestatario se
                        compromete a abonar los impuestos que resulten aplicables a la utilización de los servicios y a
                        los pagos que efectúe a favor de Acreditante.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        4.- Desembolso del Crédito
                    </h2>
                    <p className="text-justify">
                        Se considerará que todas las cantidades de las que el Prestatario disponga en virtud del Crédito
                        le han sido desembolsadas en el día de firma de los Documentos del Crédito, con independencia de
                        la fecha en que le sean efectivamente entregadas al Prestatario.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        5.- Investigación
                    </h2>
                    <p className="text-justify">
                        El Prestatario autoriza al Acreditante a llevar a cabo, de forma directa o por medio de
                        terceros, todas las investigaciones que estime necesarias para validar la información financiera
                        facilitada con motivo de la contratación de los servicios.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        6.- Pagos y pagos anticipados
                    </h2>
                    <p className="text-justify">
                        Todos los pagos del Crédito deberán realizarse en la forma y términos que indiquen los
                        Documentos del Crédito.
                    </p>
                    <p className="text-justify mt-4">
                        En caso de que las cuotas establecidas en los Documentos del Crédito se amorticen de forma
                        anticipada en una fecha anterior a la establecida para su pago, el Acreditante podrá cobrar al
                        Prestatario una pena de acuerdo con lo establecido dentro de los Documentos del Crédito.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        7.- Promociones
                    </h2>
                    <p className="text-justify">
                        Ocasionalmente, el Acreditante publicará ofertas especiales y promociones. Dichas ofertas y
                        promociones estarán sujetas a términos y condiciones particulares que se publicarán llegado el
                        momento.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        8.- Terminación anticipada
                    </h2>
                    <p className="text-justify">
                        El Prestatario podrá pagar el total del Crédito remitiendo un aviso por escrito al Acreditante
                        con 3 (tres) días hábiles de anticipación a la fecha de la liquidación, previo reembolso al
                        Acreditante de los Intereses y demás importes vencidos con arreglo a los Documentos del Crédito
                        y a las Condiciones Generales.
                    </p>
                    <p className="text-justify mt-4">
                        El Acreditante podrá dar por resuelto unilateralmente el Crédito con carácter inmediato y
                        declarar vencido e inmediatamente exigible el importe pendiente y los intereses devengados hasta
                        ese momento en su virtud, en caso de que se produzca un cambio adverso significativo que afecte
                        al negocio, operaciones, inmuebles, perspectivas, activos o situación del Prestatario o de que
                        concurra cualquier acontecimiento o circunstancia que pueda dar lugar a dicho cambio adverso
                        significativo (en lo sucesivo, un "Cambio Adverso Significativo"), tales como, iniciar un
                        proceso de concurso mercantil y/o en caso de insolvencia económica y/o en caso de ser sujeto a
                        un proceso de investigación por parte de cualquier autoridad en temas de delitos patrimoniales.
                        En caso de ser persona moral e iniciar un procedimiento de fusión, escisión o disolución. En
                        caso de fallecimiento. En caso de que el Prestatario incurra en una calificación negativa y/o
                        por debajo de los estándares aceptados por el Acreditante, de acuerdo con la información
                        obtenida de las sociedades de información crediticia.
                    </p>
                    <p className="text-justify mt-4">
                        El hecho de que Acreditante resuelva el Crédito de conformidad con lo dispuesto en estas
                        Condiciones Generales o en los Documentos del Crédito, no le impedirá solicitar una
                        indemnización por los perjuicios que efectivamente se le irroguen, cuando tales perjuicios
                        excedan de los importes del Crédito y sus Accesorios.
                    </p>
                    <p className="text-justify mt-4">
                        Mientras persistan las circunstancias que pueden dar lugar un Cambio Adverso Significativo, el
                        derecho del Prestatario a disponer de los fondos del Crédito quedará suspendido sin necesidad de
                        aviso previo.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        9.- Pena por atrasos en los pagos del Crédito
                    </h2>
                    <p className="text-justify">
                        En caso de que el Prestatario incumpla las obligaciones de pago contenidas en los Documentos del
                        Crédito y no subsane su incumplimiento en un plazo máximo de 3 (tres) días hábiles, y siempre
                        cuando esa o cualquier otra obligación de reembolso se mantenga pendiente y vencida, la tasa de
                        interés referida moratorio no podrá ser menor al 25 por ciento mensual + IVA.
                    </p>
                    <p className="text-justify mt-4">
                        Por concepto de gastos de administración por impuntualidad en los pagos del Crédito, y sin que
                        para ello Acreditante deba demostrar perjuicio alguno, el Prestatario pagará al Acreditante una
                        tasa de interés del 0% por ciento de cada obligación de pago incumplida (por el Prestatario) de
                        acuerdo con los Documentos del Crédito (de ahora en adelante "Gastos de Administración").
                    </p>
                    <p className="text-justify mt-4">
                        Todos los pagos del Crédito se pagarán en el siguiente orden:
                    </p>
                    <ul className="list-disc pl-8 mt-2 space-y-2">
                        <li>En primer lugar, al pago de los Gastos de Administración.</li>
                        <li>A continuación, al pago de Intereses Moratorios.</li>
                        <li>A continuación, al pago de Intereses Ordinarios.</li>
                        <li>A continuación, al pago de otros gastos distintos de Intereses (en su caso); y</li>
                        <li>Por último, al pago del capital.</li>
                    </ul>
                </div>
                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        10.- Resolución
                    </h2>
                    <p className="text-justify">
                        Para que Acreditante ponga a disposición del Prestatario el Crédito, el Prestatario formula a su
                        favor las manifestaciones que se enumeran a continuación, las cuales permanecerán en vigor hasta
                        que el Prestatario tenga una deuda con Acreditante en virtud de estas Condiciones Generales y/o
                        los Documentos del Crédito y se hayan abonado íntegramente todas las cantidades pendientes en su
                        virtud.
                    </p>
                    <p className="text-justify mt-4">
                        (I). - El otorgamiento del Crédito no llevará aparejada de manera inmediata, con el paso del
                        tiempo o con motivo de su resolución, o por una combinación de ambas lo siguiente:
                    </p>
                    <ul className="list-disc pl-8 mt-2 space-y-2">
                        <li>La vulneración de una ley o un incumplimiento con arreglo a cualquier contrato, acuerdo o
                            instrumento del que el Prestatario sea parte o que le vincule a sí o a sus activos; ni</li>
                        <li>La creación o imposición de un derecho real de garantía, derecho de retención o gravamen
                            sobre los activos del Prestatario.</li>
                    </ul>
                    <p className="text-justify mt-4">
                        (II). -El Prestatario está plenamente facultado para contraer y cumplir las obligaciones y, en
                        caso de tratarse de una persona moral, ha adoptado todas las medidas societarias o de otro tipo
                        necesarias para autorizar el otorgamiento del Crédito.
                    </p>
                    <p className="text-justify mt-4">
                        (III). - El Prestatario ha presentado todas las declaraciones fiscales que estaba legalmente
                        obligado a presentar con anterioridad a la fecha del Crédito, ha abonado o dispuesto el pago de
                        todos los impuestos, contribuciones y/o derechos pagaderos con anterioridad a la fecha del
                        Crédito y ha dotado provisiones suficientes para el pago de los impuestos, derechos y/o
                        contribuciones devengadas, pero aún no exigibles.
                    </p>
                    <p className="text-justify mt-4">
                        (IV). - Salvo en la medida en que su incumplimiento no interfiera de manera significativa con el
                        ejercicio de su actividad, el Prestatario ha cumplido toda la legislación aplicable reguladora
                        de: (1) restricciones, especificaciones u otros requisitos relacionados con su actividad y (2)
                        el uso, mantenimiento y funcionamiento de sus activos.
                    </p>
                    <p className="text-justify mt-4">
                        (v). - Ninguna manifestación formulada por el Acreditante que se contenga en los Documentos del
                        Crédito o en cualquier documento que haya entregado en virtud del Crédito, contiene
                        declaraciones falsas sobre un hecho importante u omite un hecho importante necesario para
                        otorgar dicha manifestación o garantía, ni es engañosa a la luz de las circunstancias en las que
                        se formuló.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        11.- Otras obligaciones
                    </h2>
                    <p className="text-justify">
                        El Prestatario deberá entregar al Acreditante, previa solicitud, y en forma y contenido
                        satisfactorios a juicio de Acreditante, el número de ejemplares que Acreditante le indique de:
                    </p>
                    <ul className="list-disc pl-8 mt-2 space-y-2">
                        <li>Sus cuentas anuales en un plazo de seis meses a contar desde el cierre del ejercicio fiscal,
                            o cualquier otro plazo que Acreditante razonablemente solicite;</li>
                        <li>Copia cotejada (por el Acreditante) con el original de sus recibos de pago.</li>
                    </ul>
                    <p className="text-justify mt-4">
                        El Prestatario deberá notificar al Acreditante cualquier circunstancia susceptible de influir
                        negativamente en sus activos y situación financiera y que pueda tener una incidencia
                        significativa sobre su capacidad para cumplir sus obligaciones en virtud del presente Contrato.
                    </p>
                    <p className="text-justify mt-4">
                        El Acreditante deberá entregar al Prestatario previo su solicitud lo siguiente:
                    </p>
                    <ul className="list-disc pl-8 mt-2 space-y-2">
                        <li>Copia de su estado de cuenta</li>
                        <li>Constancia de recepción de pago (cada que se reciba un pago)</li>
                        <li>Constancia de liquidación del Crédito en caso de pago total del Crédito.</li>
                    </ul>
                </div>
                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        12.- Limitación de responsabilidad
                    </h2>
                    <p className="text-justify">
                        Acreditante no responderá en modo alguno frente al Prestatario por el uso que le dé al Crédito
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        13.- Cesión
                    </h2>
                    <p className="text-justify">
                        Acreditante podrá ceder en forma total o parcial sus derechos y obligaciones contenidos en las
                        presentes Condiciones Generales o Documentos del Crédito a un tercero.
                    </p>
                    <p className="text-justify mt-4">
                        Por su parte el Acreditante no podrá ceder en forma total o parcial los derechos del Crédito
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        14.- Notificaciones
                    </h2>
                    <p className="text-justify">
                        Toda notificación que deba o pueda efectuarse en virtud del Crédito deberá constar por escrito y
                        enviarse a las direcciones de correo electrónico que se faciliten por escrito a la otra parte.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        15.- Nulidad
                    </h2>
                    <p className="text-justify">
                        Los apartados de las Condiciones Generales y Documentos del Crédito son independientes las unas
                        de las otras. En caso de que un tribunal competente declare que alguna(s), es nula, ilícita o
                        inexigible, la intención de las partes es que el tribunal limite el alcance de dicha apartado,
                        condición o disposición exclusivamente en la medida en que lo estime necesario para que resulte
                        razonable y exigible, y que tal circunstancia no afecte, perjudique ni invalide las restantes
                        disposiciones. </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        16.- Consentimiento para uso de datos personales
                    </h2>
                    <p className="text-justify">
                        El Acreditante acepta y reconoce, Asimismo, el usuario que contrate un crédito otorga su
                        consentimiento para que el Acreditante realice el envío de promociones y/o recordatorios de pago
                        y/o gestiones de cobro por si mismo o por medio de un tercero, asimismo el Prestatario autoriza
                        para que en caso de incumplimiento se realicen gestiones de cobro a los datos de contacto que ha
                        proporcionado. Por último el Prestatario manifiesta que conoce el aviso de privacidad del
                        Acreditante mismo que acepta.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        17.- Derecho aplicable
                    </h2>
                    <p className="text-justify">
                        Para cualquier cuestión que se suscite con motivo las Condiciones Generales o de los Documentos
                        del Crédito o del Crédito las Partes se someten a la jurisdicción y competencia de los
                        Tribunales del orden común de la Ciudad de México renunciando en este acto a cualquier otra
                        jurisdicción o competencia que pudiera corresponderles en razón de sus domicilios presentes y/o
                        futuros o por cualquier otra causa.
                    </p>
                </div>

                <div>
                    <h2 className="text-lg font-bold text-customPurple-600 mb-2">
                        18.- Aceptación de las Condiciones Generales
                    </h2>
                    <p className="text-justify">
                        El Prestatario manifiesta que: (i) Está en pleno uso y goce de sus facultades físicas y
                        mentales, por lo cual puede leer y las presentes Condiciones Generales. (ii) Ha presentado y en
                        su caso seguirá presentando información veraz al Acreditante. (iii) Sabe y conoce el contenido,
                        así como el alcance legal de las presentes Condiciones Generales. (iv) Ha leído en su totalidad
                        las Condiciones Generales, por lo cual está de acuerdo con las mismas y otorga su total
                        aceptación; asimismo se compromete a cumplirlas en su totalidad.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <app-footer [colorClass]="footerColorClass"></app-footer>
</div>